<template>
    <div class="row">
        <!-- Index -->
        <div class="col-2">
            <h6><fa-icon icon="align-left" /> Feature Map</h6>
            <ul class="list-unstyled">
                <li v-for="(feature, idx) in features" :key="idx">
                    <span class="feature-title pointer" :class="{selected:slideOffset===idx}" @click="slideOffset=idx">
                        <fa-icon v-if="slideOffset===idx" icon="caret-right" />
                        {{ feature.title }}
                    </span>
                    <ul class="scenarios">
                        <li v-for="(scenario, iidx) in feature.scenarios" :key="iidx"><span class="badge" :class="{'badge-danger': typeof scenario.isDone==='undefined' || !scenario.isDone, 'badge-success': scenario.isDone}">scenario</span> {{ scenario.title }}</li>
                    </ul>
                    {{ featureFinishedRate(idx) }} <fa-icon icon="percentage"/>
                </li>
            </ul>
        </div>

        <div class="col-7">
            <div class="row">
                <ul class="list-inline">
                    <li class="list-inline-item" v-for="(tag, idx) in project.tags" :key="idx">
                        <span class="badge badge-info">{{ tag }}</span>
                    </li>
                </ul>
            </div>

            <div class="row">
                <carousel class="col-10 bdd" :navigateTo="slideOffset" :perPage="1" :scrollPerPage="true" :navigationEnabled="true" :paginationEnabled="false" @navigation-click="onNavigationClick($event)" @page-change="onPageChange">
                    <!-- Feature -->
                    <slide v-for="(feature, idx) in features" :key="idx">
                        <h6 class="mt-2"><a href="javascript:;" class="text-danger" @click="dropFeature(idx)"><fa-icon icon="trash" /></a><b> Feature:</b> {{ feature.title }}</h6>
                        <div class="feature-description">
                            <div v-if="feature.options.hasInOrderTo">In order to {{ feature.description.txtInOrderTo }}</div>
                            <div v-if="feature.options.hasIShouldBe">I should be {{ feature.description.txtIShouldBe }}</div>
                            <div v-if="feature.options.hasSoThat">So that {{ feature.description.txtSoThat }}</div>
                        </div>
                        <div v-if="feature.options.hasBackground" class="ml-3 mt-3">
                            <h6><a href="javascript:;" class="text-danger" @click="dropBackground(idx)"><fa-icon icon="trash" /></a><b> Background: </b></h6>
                            <div class="ml-3">
                                <div><b>Given</b> {{ feature.background.given }}</div>
                                <div v-for="(and, iidx) in feature.background.ands" :key="iidx">
                                    <b>{{ and.isBut ? 'But' : 'And' }}</b> {{ and.value }}
                                </div>
                            </div>
                        </div>

                        <div v-if="showCreateBackground" class="mt-3">
                            <h6>Background: </h6>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Given</div>
                                </div>
                                <input type="text" class="form-control" placeholder="the initial context" v-model="tmpBackground.given" />
                                <div class="input-group-append">
                                    <div class="input-group-text pointer" @click="onAddBddAnd('background')"><fa-icon icon="plus" /></div>
                                </div>
                            </div>
                            <bdd-and :ands="tmpBackground.ands" @bdd-and-type-switch="onBddAndSwitch($event, 'background')" @bdd-and-remove="onBddAndRemove($event, 'background')" @bdd-and-set-value="onBddAndSetValue($event, 'background')"></bdd-and>
                        </div>
                        <div v-if="showCreateBackground" class="form-group row mb-3">
                            <div class="col-4 mt-2">
                                <input type="button" class="form-control form-control-sm btn-primary" value="Save Background" @click="saveBackground(idx)">
                            </div>
                        </div>

                        <!-- Buttons -->
                        <div>
                            <ul class="list-inline">
                                <li class="list-inline-item"><file-download title="Feature" :downloadName="featureFilename(feature)" :data="featureText()" /></li>
                                <li class="list-inline-item"><a href="javascript:;" @click="showCreateBackground=!showCreateBackground"><fa-icon :icon="showCreateBackground ? 'minus-square' : 'plus-square'" /> Background</a></li>
                                <li class="list-inline-item"><a href="javascript:;" @click="showCreateScenario=!showCreateScenario"><fa-icon :icon="showCreateScenario ? 'minus-square' : 'plus-square'" /> Scenario</a></li>
                            </ul>
                        </div>

                        <!-- Create Scenario -->
                        <div v-if="showCreateScenario" class="input-group mb-1">
                            <div class="input-group-prepend">
                                <div class="input-group-text pointer" @click="tmpScenario.isOutline=!tmpScenario.isOutline">Scenario{{ tmpScenario.isOutline ? ' outline' : '' }}: </div>
                            </div>
                            <input type="text" class="form-control" placeholder="title of the scenario" v-model="tmpScenario.title" />
                        </div>
                        <div v-if="showCreateScenario">
                            <ul class="list-inline">
                                <li class="list-inline-item"><label><input type="checkbox" v-model="tmpScenario.options.hasGiven" /> Given</label></li>
                                <li class="list-inline-item"><label><input type="checkbox" v-model="tmpScenario.options.hasWhen" /> When</label></li>
                                <li class="list-inline-item"><label><input type="checkbox" v-model="tmpScenario.options.hasThen" /> Then</label></li>
                            </ul>
                        </div>
                        <div v-if="showCreateScenario && tmpScenario.options.hasGiven">
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Given</div>
                                </div>
                                <input type="text" class="form-control" placeholder="the initial context" v-model="tmpScenario.given.given" />
                                <div class="input-group-append">
                                    <div class="input-group-text pointer" @click="onAddBddAnd('given')"><fa-icon icon="plus" /></div>
                                </div>
                            </div>
                            <bdd-and :ands="tmpScenario.given.ands" @bdd-and-type-switch="onBddAndSwitch($event, 'given')" @bdd-and-remove="onBddAndRemove($event, 'given')" @bdd-and-set-value="onBddAndSetValue($event, 'given')"></bdd-and>
                        </div>
                        <div v-if="showCreateScenario && tmpScenario.options.hasWhen">
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">When</div>
                                </div>
                                <input type="text" class="form-control" placeholder="the event that triggers the scenario" v-model="tmpScenario.when.when" />
                                <div class="input-group-append">
                                    <div class="input-group-text pointer" @click="onAddBddAnd('when')"><fa-icon icon="plus" /></div>
                                </div>
                            </div>
                            <bdd-and :ands="tmpScenario.when.ands" @bdd-and-type-switch="onBddAndSwitch($event, 'when')" @bdd-and-remove="onBddAndRemove($event, 'when')" @bdd-and-set-value="onBddAndSetValue($event, 'when')"></bdd-and>
                        </div>
                        <div v-if="showCreateScenario && tmpScenario.options.hasThen">
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Then</div>
                                </div>
                                <input type="text" class="form-control" placeholder="the expected outcome" v-model="tmpScenario.then.then" />
                                <div class="input-group-append">
                                    <div class="input-group-text pointer" @click="onAddBddAnd('then')"><fa-icon icon="plus" /></div>
                                </div>
                            </div>
                            <bdd-and :ands="tmpScenario.then.ands" @bdd-and-type-switch="onBddAndSwitch($event, 'then')" @bdd-and-remove="onBddAndRemove($event, 'then')" @bdd-and-set-value="onBddAndSetValue($event, 'then')"></bdd-and>
                        </div>
                        <div v-if="showCreateScenario && tmpScenario.isOutline" class="mt-1">
                            <div class="input-group input-group-sm">
                                <label>
                                    Examples:
                                    <textarea class="form-control" style="width: 26rem; min-height: 5rem;" placeholder="| key1 | key2 | key3 |
| v1    | v2    | v3    |" v-model="tmpScenario.examples"></textarea>
                                </label>
                            </div>
                        </div>
                        <div v-if="showCreateScenario" class="form-group row">
                            <div class="col-3 mt-2">
                                <input type="button" class="form-control form-control-sm btn-primary" value="Add Scenario" @click="newScenario(idx)">
                            </div>
                        </div>

                        <!-- List -->
                        <div class="scenarios ml-3">
                            <div class="m-3" v-for="(scenario, sidx) in feature.scenarios" :key="sidx">
                                <h6><a href="javascript:;" class="text-danger" @click="dropScenario(idx, sidx)"><fa-icon icon="trash" /></a><b> Scenario{{ scenario.isOutline ? ' Outline' : '' }}:</b> {{ scenario.title }} <label class="mb-1"><input type="checkbox" :checked="scenario.isDone" @change="toggleDone(idx, sidx)" /></label></h6>
                                <div class="ml-4">
                                    <div v-if="scenario.options.hasGiven">
                                        <div>
                                            <b>Given</b> {{ scenario.given.given }}
                                        </div>
                                        <div v-for="(and, iidx) in scenario.given.ands" :key="iidx">
                                            <b>{{ and.isBut ? 'But' : 'And' }}</b> {{ and.value }}
                                        </div>
                                    </div>
                                    <div v-if="scenario.options.hasWhen">
                                        <div>
                                            <b>When</b> {{ scenario.when.when }}
                                        </div>
                                        <div v-for="(and, iidx) in scenario.when.ands" :key="iidx">
                                            <b>{{ and.isBut ? 'But' : 'And' }}</b> {{ and.value }}
                                        </div>
                                    </div>
                                    <div v-if="scenario.options.hasThen">
                                        <div>
                                            <b>Then</b> {{ scenario.then.then }}
                                        </div>
                                        <div v-for="(and, iidx) in scenario.then.ands" :key="iidx">
                                            <b>{{ and.isBut ? 'But' : 'And' }}</b> {{ and.value }}
                                        </div>
                                    </div>
                                    <div v-if="scenario.isOutline" class="mt-2">
                                        <div>
                                            <b>Examples:</b>
                                        </div>
                                        <pre>{{ scenario.examples }}</pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </slide>

                    <!-- Add Feature -->
                    <slide>
                        <div class="form-group row">
                            <label class="col-2 col-form-label">Feature:</label>
                            <div class="col-8">
                                <input type="text" class="form-control form-control-sm" placeholder="title of the feature" v-model="tmpFeature.title"/>
                            </div>
                        </div>
                        <div class="input-group input-group-sm">
                            <h6>Description:
                                <ul class="list-inline">
                                    <li class="list-inline-item"><label><input type="checkbox" v-model="tmpFeature.options.hasInOrderTo"> In order to</label></li>
                                    <li class="list-inline-item"><label><input type="checkbox" v-model="tmpFeature.options.hasIShouldBe"> I should be</label></li>
                                    <li class="list-inline-item"><label><input type="checkbox" v-model="tmpFeature.options.hasSoThat"> So that</label></li>
                                </ul>
                            </h6>
                        </div>
                        <div v-if="tmpFeature.options.hasInOrderTo" class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <div class="input-group-text">In order to</div>
                            </div>
                            <input type="text" class="form-control" placeholder="the feature" v-model="tmpFeature.description.txtInOrderTo" />
                        </div>
                        <div v-if="tmpFeature.options.hasIShouldBe" class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <div class="input-group-text">I should be</div>
                            </div>
                            <input type="text" class="form-control" placeholder="some role" v-model="tmpFeature.description.txtIShouldBe" />
                        </div>
                        <div v-if="tmpFeature.options.hasSoThat" class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <div class="input-group-text">So that</div>
                            </div>
                            <input type="text" class="form-control" placeholder="I can have the benifit of the feature" v-model="tmpFeature.description.txtSoThat" />
                        </div>
                        <div class="form-group row">
                            <div class="col-3 mt-2">
                                <input type="button" class="form-control form-control-sm btn-primary" value="Add Feature" @click="newFeature()">
                            </div>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>

        <div v-if="slideOffset < features.length" class="col-3">
            <div class="row">
                <h6>Vocabulary:</h6>
            </div>
            <div class="row">
                <ul class="list-unstyled">
                    <li class="" v-for="(tag, idx) in autoTags" :key="idx">
                        <span class="badge badge-info pointer" @click="vocabularySet(tag)"><fa-icon icon="caret-left"/> noun</span>
                        <span class="badge pointer" :class="{'badge-info':nouns.indexOf(tag)!==-1, 'badge-danger':verbs.indexOf(tag)!==-1}" @click="vocabularyRemove(tag)">{{ tag }}</span>
                        <span class="badge badge-danger pointer" @click="vocabularySet(tag, ['verbs', 'nouns'])">verb <fa-icon icon="caret-right" /></span>
                    </li>
                </ul>
            </div>
            <div class="row">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <button class="btn btn-primary btn-sm" @click="$router.push({name: 'home'})">Projects</button>
                    </li>
                    <li class="list-inline-item">
                        <button class="btn btn-primary btn-sm" @click="$router.push({name: 'static-diagram'})">Go to Static</button>
                    </li>
                    <li class="list-inline-item">
                        <button class="btn btn-primary btn-sm" @click="$router.push({name: 'dynamic-diagram'})">Go to Dynamic</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .feature-title.selected {
        color: var(--primary);
    }

    ul.scenarios {
        font-size: .8rem;
        padding-inline-start: 0;
        list-style: inside none;
        color: var(--gray);
    }

    .bdd .form-group {
        margin-bottom: 0;
    }

    .bdd h6 {
        margin-block-start: 0;
        margin-block-end: 0;
    }

    .bdd a {
        text-decoration: none;
    }

    .bdd ul {
        margin-block-end: 0;
    }

    .bdd .feature-description {
        padding-left: 1rem;
    }

</style>

<script>
    import slug from 'slug';
    import moment from 'moment';
    import { mapState } from 'vuex';
    import * as ke from 'keyword-extractor';
    import { Carousel, Slide } from 'vue-carousel';
    import BddAnd from '@/components/BddAnd';
    import FileDownload from '@/components/FileDownload';
    import { FEATURE_ADD, FEATURE_REMOVE, SCENARIO_ADD, SCENARIO_TOGGLE_DONE, SCENARIO_REMOVE, VOCABULARY_SET,VOCABULARY_REMOVE,BACKGROUND_SET,BACKGROUND_RESET,TASK_REMOVE, TASK_TOGGLE_DONE, TASK_ADD } from '../mutation-types';

    export default  {
        data() {
            return {
                tags: [],

                slideOffset: 0,

                tmpFeature: {title: '', options: {hasInOrderTo: true, hasIShouldBe: true, hasSoThat: true, hasBackground: false}, description:{txtInOrderTo: '', txtIShouldBe: '', txtSoThat: ''}, background: {given: '', ands: []}},

                showCreateBackground: false,
                tmpBackground: {given: '', ands: []},

                showCreateScenario: false,
                tmpScenario: {title: '', isDone: false, isOutline: false, options: {hasGiven: true, hasWhen: true, hasThen: true}, given: {given: '', ands: []}, when: {when: '', ands: []}, then: {then: '', ands: []}, examples: ''}
            }
        },

        computed: {
            ...mapState(['project', 'features', 'nouns', 'verbs']),
            featureFinishedRate: function() {
                return function(idx) {
                    const total = this.features[idx].scenarios.length;
                    if (total === 0) return 0;
                    const n = this.features[idx].scenarios.reduce((i, v) => {
                        if (v.isDone) i += 1;
                        return i;
                    }, 0);
                    return (n / total * 100).toFixed(0);
                };
            },

            featureText: function() {
                return function(withPrefix = true) {
                    if (this.slideOffset >= this.features.length) return '';

                    const v = this.features[this.slideOffset];
                    let s = '';
                    s += (withPrefix ? 'Feature: ' : '') + v.title + '\n';
                    if (v.options.hasInOrderTo) s += (withPrefix ? '  In order to ' : '') + v.description.txtInOrderTo + '\n';
                    if (v.options.hasIShouldBe) s += (withPrefix ? '  I should be ' : '') + v.description.txtIShouldBe + '\n';
                    if (v.options.hasSoThat) s += (withPrefix ? '  So that ' : '') + v.description.txtSoThat + '\n';
                    s += '\n';

                    if (v.options.hasBackground) {
                        s += withPrefix ? '  Background:\n' : '';
                        s += (withPrefix ? '    Given ' : '') + v.background.given + '\n';
                        v.background.ands.forEach(t => s += (withPrefix ? (t.isBut ? '    But ' : '    And ') : '') + t.value + '\n');
                        s += '\n';
                    }

                    v.scenarios.forEach(vv => {
                        s += (withPrefix ? (vv.isOutline ? '  Scenario Outline: ' : '  Scenario: ') : '') + vv.title + '\n';
                        if (vv.options.hasGiven) {
                            s += (withPrefix ? '    Given ' : '') + vv.given.given + '\n';
                            vv.given.ands.forEach(t => s += (withPrefix ? (t.isBut ? '    But ' : '    And ') : '') + t.value + '\n');
                        }
                        if (vv.options.hasWhen) {
                            s += (withPrefix ? '    When ' : '') + vv.when.when + '\n';
                            vv.when.ands.forEach(t => s += (withPrefix ? (t.isBut ? '    But ' : '    And ') : '') + t.value + '\n');
                        }
                        if (vv.options.hasThen) {
                            s += (withPrefix ? '    Then ' : '') + vv.then.then + '\n';
                            vv.then.ands.forEach(t => s += (withPrefix ? (t.isBut ? '    But ' : '    And ') : '') + t.value + '\n');
                        }
                        s += "\n";

                        if (vv.isOutline && withPrefix) { // + examples
                            s += '    Examples:\n';
                            s += vv.examples.trim().split('\n').map(v => '      ' + v + '\n').join('') + '\n';
                        }
                    });

                    return s;
                };
            },

            autoTags() {
                return ke.extract(this.featureText(false), {language: 'english', remove_digits: true, return_changed_case: true, return_chained_words: true, remove_duplicates: true});
            }
        },

        methods: {
            featureFilename(feature) {
                return slug(feature.title, {mode: 'rfc3986'}) + '.feature';
            },

            async newFeature() {
                let id = await this.$db.features.add({
                    pid: this.project.id,
                    ...this.tmpFeature,
                    scenarios: [],
                    created: +moment(),
                    updated: +moment()
                });
                let feature = await this.$db.features.get(id);
                this.$store.commit(FEATURE_ADD, feature);

            },

            async dropFeature(idx) {
                await this.$db.features.delete(this.features[idx].id);
                this.$store.commit(FEATURE_REMOVE, idx);
            },

            async saveBackground(idx) {
                await this.$db.features.update(this.features[idx].id, {'options.hasBackground': true, background: this.tmpBackground});
                this.$store.commit(BACKGROUND_SET, {idx, background: {...this.tmpBackground}});
                this.tmpBackground = {given: '', ands: []}; // reset to empty
            },

            async dropBackground(idx) {
                await this.$db.features.update(this.features[idx].id, {'options.hasBackground': false, background: {given: '', ands: []}});
                this.$store.commit(BACKGROUND_RESET, idx);
                this.tmpBackground = {given: '', ands: []};
            },

            async newScenario(idx) {
                // create new task
                const id = await this.$store.dispatch('addTask', {db: this.$db, from: 'scenario', task: this.tmpScenario.title});
                this.tmpScenario.taskId = id;
                this.$store.commit(SCENARIO_ADD, {idx, scenario: {...this.tmpScenario}});
                await this.$db.features.update(this.features[idx].id, {scenarios: this.features[idx].scenarios});
            },

            async dropScenario(idx, sidx) {
                let feature = this.features[idx];
                const taskId = feature.scenarios[sidx].taskId;
                feature.scenarios.splice(sidx, 1);
                await this.$db.features.update(feature.id, {scenarios: feature.scenarios});
                // this.$store.commit(SCENARIO_REMOVE, {idx, sidx});
                // TODO: reference seems work
                await this.$db.tasks.delete(taskId);
                this.$store.commit(TASK_REMOVE, taskId);
            },

            async toggleDone(idx, sidx) {
                let feature = this.features[idx];
                feature.scenarios[sidx].isDone = !feature.scenarios[sidx].isDone;
                await this.$db.features.update(this.features[idx].id, {scenarios: feature.scenarios});
                this.$store.commit(SCENARIO_TOGGLE_DONE, {idx, sidx, isDone: feature.scenarios[sidx].isDone});
                await this.$db.tasks.update(feature.scenarios[sidx].taskId, {isDone: feature.scenarios[sidx].isDone});
                this.$store.commit(TASK_TOGGLE_DONE, {id: feature.scenarios[sidx].taskId, isDone: feature.scenarios[sidx].isDone});
            },

            async vocabularySet(tag, order=['nouns', 'verbs']) {
                if (this.slideOffset >= this.features.length) return;

                const pid = this.features[this.slideOffset].pid;
                let vocabulary = await this.$db.vocabularies.get({pid});
                if (typeof vocabulary === 'undefined') {
                    vocabulary = {};
                    vocabulary[order[0]] = [tag];
                    vocabulary[order[1]] = [];
                    vocabulary.used = [];
                    await this.$db.vocabularies.add({pid, ...vocabulary});
                } else {
                    let i;
                    if ((i = vocabulary[order[0]].indexOf(tag)) === -1) { // not found
                        vocabulary[order[0]].push(tag);
                    }
                    if ((i = vocabulary[order[1]].indexOf(tag)) !== -1) { // but in
                        vocabulary[order[1]].splice(i, 1);
                    }

                    // save
                    await this.$db.vocabularies.update(vocabulary.id, {nouns: vocabulary.nouns, verbs: vocabulary.verbs});
                }

                this.$store.commit(VOCABULARY_SET, {tag, order});
            },

            async vocabularyRemove(tag) {
                if (this.slideOffset >= this.features.length) return;
                const pid = this.features[this.slideOffset].pid;
                let vocabulary = await this.$db.vocabularies.get({pid});
                if (typeof vocabulary !== 'undefined') {
                    let i = vocabulary.nouns.indexOf(tag);
                    if (i !== -1) vocabulary.nouns.splice(i, 1);
                    i = vocabulary.verbs.indexOf(tag);
                    if (i !== -1) vocabulary.verbs.splice(i, 1);
                    await this.$db.vocabularies.update(vocabulary.id, {...vocabulary});
                }
                this.$store.commit(VOCABULARY_REMOVE, tag);
            },

            onNavigationClick(payload) {
                const handlers = {
                    forward: () => {if (this.slideOffset < this.features.length) this.slideOffset++},
                    backward: () => {if (this.slideOffset > 0) this.slideOffset--; }
                };
                handlers[payload].call(this);
                // TODO: reset
            },

            onPageChange(n) {
                this.slideOffset = n;
            },

            onBddAndSwitch(idx, k) {
                const p = k === 'background' ? this.tmpBackground : this.tmpScenario[k];
                p.ands[idx].isBut = !p.ands[idx].isBut;
            },

            onAddBddAnd(k) {
                const p = k === 'background' ? this.tmpBackground : this.tmpScenario[k];
                p.ands.push({isBut: false, value: ''});
            },

            onBddAndRemove(idx, k) {
                const p = k === 'background' ? this.tmpBackground : this.tmpScenario[k];
                if (idx < p.ands.length) {
                    p.ands.splice(idx, 1);
                }
            },

            onBddAndSetValue(payload, k) {
                const p = k === 'background' ? this.tmpBackground : this.tmpScenario[k];
                const idx = payload.idx;
                if (typeof p.ands[idx] !== 'undefined') {
                    p.ands[idx].value = payload.v;
                }
            }
        },

        components: {
            FileDownload,
            Carousel, Slide, BddAnd
        }
    }
</script>
